import React from 'react';
import { useAuth } from '../context/AuthContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiAlertTriangle } = FiIcons;

function ProtectedRoute({ children, permission, permissions, fallback }) {
  const { hasPermission, hasAnyPermission, user } = useAuth();

  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <SafeIcon icon={FiLock} className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Authentication Required</h3>
          <p className="text-gray-500">Please log in to access this feature.</p>
        </div>
      </div>
    );
  }

  // Check single permission
  if (permission && !hasPermission(permission)) {
    return fallback || (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <SafeIcon icon={FiAlertTriangle} className="w-16 h-16 text-orange-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Access Denied</h3>
          <p className="text-gray-500">You don't have permission to access this feature.</p>
        </div>
      </div>
    );
  }

  // Check multiple permissions (any)
  if (permissions && !hasAnyPermission(permissions)) {
    return fallback || (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <SafeIcon icon={FiAlertTriangle} className="w-16 h-16 text-orange-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Access Denied</h3>
          <p className="text-gray-500">You don't have permission to access this feature.</p>
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;